import { Button, Divider, Stack, Text } from '@chakra-ui/react';
import { ReactElement, useState } from 'react';

import MfaSmsIcon from '../../../../atoms/mfa-sms-icon';
import { PhoneNumberInput } from '../../../../formInputs/PhoneNumberInput';
import { IPhone } from '../../../../../types';
import { MFAHeader } from '../../MFAHeader';
import { MFAStep } from '../../MFAStep';
import { Title } from '../../../../atoms/Title';

export interface IMfaSetupSms {
  onSubmit: (phoneNumber: string) => void;
  onChooseDifferent: () => void;
  onSignOut: () => void;
}

const assemblePhoneNumber = (phoneNumber: IPhone): string => `+${phoneNumber.code}${phoneNumber.phone}`;

export default function MfaSetupSms({ onSubmit, onChooseDifferent }: IMfaSetupSms): ReactElement {
  const [phoneNumber, setPhoneNumber] = useState<IPhone>();
  const [isPhoneNumberValid, setPhoneNumberValid] = useState(true);

  const handleSubmitClick = () => {
    if (phoneNumber && isPhoneNumberValid) {
      onSubmit(assemblePhoneNumber(phoneNumber));
    }
  };

  const title = 'Send a code to a phone number';

  return (
    <>
      <Title title={title} />

      <MFAHeader icon={<MfaSmsIcon />}>{title}</MFAHeader>

      <MFAStep number={1} title={'Enter your phone number'}>
        <Text mb={0}>If you are a student enter the number used for your application.</Text>

        <PhoneNumberInput
          key="phone"
          id="phone"
          codeValue={phoneNumber && phoneNumber.code ? phoneNumber.code : ''}
          numberValue={phoneNumber && phoneNumber.phone ? phoneNumber.phone : ''}
          onValidationFailed={() => {
            setPhoneNumberValid(false);
          }}
          onValidationSuccess={() => {
            const { code, phone } = phoneNumber!;
            setPhoneNumberValid(true);
            setPhoneNumber({ code, phone });
          }}
          onChangeCode={(event: React.FormEvent<HTMLInputElement>) => {
            const code = event.currentTarget.value;
            setPhoneNumber({
              phone: phoneNumber ? phoneNumber.phone : '',
              code,
            });
          }}
          onChangeNumber={(event: React.FormEvent<HTMLInputElement>) => {
            const { value } = event.currentTarget;
            setPhoneNumber({
              phone: value,
              code: phoneNumber ? phoneNumber.code : '',
            });
          }}
        />
      </MFAStep>

      <Divider />

      <MFAStep number={2} title={'Send a text message with your code'}>
        <Text>Click the button below and enter the 6-digit code you receive on the following page.</Text>

        <Button onClick={handleSubmitClick} isDisabled={!isPhoneNumberValid} variant={'solid'} size={'lg'}>
          Send text message
        </Button>
      </MFAStep>

      <Stack mt={12}>
        <Button onClick={onChooseDifferent} variant={'secondary'} size={'lg'} data-selector="mfa-choose-different">
          Use a different method
        </Button>
      </Stack>
    </>
  );
}
